import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=2fc88ab8&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=2fc88ab8&prod&lang=stylus&rel=stylesheet%2Fstylus"
import style1 from "./Base.vue?vue&type=style&index=1&id=2fc88ab8&prod&lang=stylus&scoped=true"
import style2 from "./Base.vue?vue&type=style&index=2&id=2fc88ab8&prod&scoped=true&media=print&lang=css"
import style3 from "./Base.vue?vue&type=style&index=3&id=2fc88ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc88ab8",
  null
  
)

export default component.exports